/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-redeclare */
/* eslint-disable block-scoped-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable max-len */
/* eslint-disable func-names */
/* eslint-disable consistent-return */
import {
  parseTime, convertTime12to24,
} from '../helpers';
import {
  timeToFloat,
  updateActivityPeriodCallback,
  updateTaskTrackedTimeCallback,
  removeTaskTrackedTimeCallback,
  validStringForTime,
  validStringForFloat,
  updateColorOfTaskClockIcon,
} from './shared';

$(document).ready(() => {
  $(document).on('click', '#employee_activity_periods .fa-stopwatch', function (e) {
    e.stopPropagation();
    if ($(this).hasClass('fa-stopwatch')) {
      var workingTimeSpan = $(this).parent();
    } else {
      var workingTimeSpan = $(this);
    }
    const popup = workingTimeSpan.closest('.ui-dialog');
    popup.hide();
    const callback = function () {
      const options = parseTime(workingTimeSpan.text());
      options.duration = false;
      options.clickEvents = {
        onSave(h, m, ampm) {
          popup.show();
          saveWorkingHours(workingTimeSpan, h, m, ampm);
        },
        onClose() { popup.show(); },
      };
    };
    if (workingTimeSpan.data('needDefaultTime') === true) {
      const workingTimeType = workingTimeSpan.data('workingTimeType');
      return setDefaultForWorkingTime(workingTimeType, workingTimeSpan, callback);
    }
    callback();
  });

  $(document).on('change', '#employee_day_working_time_period_start_time, #employee_day_working_time_period_finish_time', function (e) {
    const context = $('#summary-step-data').length > 0 ? $('#summary-step-data') : $('#tasks_popup');
    console.log(context);
    const date = context.data('date');
    const projectId = context.data('projectId');
    const supervisorId = context.data('supervisorId');
    const employeeId = context.data('employeeId');
    const time = $(this).attr('id').split('_period_').at(-1);

    const data = {
      date,
      employee_id: employeeId,
      project_id: projectId,
      supervisor_id: supervisorId,
      employee_activity_period: { [time]: $(this).val(), activity_type: 'working_time' },
    };
    $.ajax({
      url: '/employee_activity_periods',
      type: 'PUT',
      data,
      success() {},
    });
  });

  function setDefaultForWorkingTime(workingTimeType, workingTimeSpan, callback) {
    const dataAttributes = $('#tasks_popup').data();
    const data = {
      supervisor_id: dataAttributes.supervisorId,
      working_time_type: workingTimeType,
    };
    $.ajax({
      url: '/planned_employee_days/default_working_time_for_employee_day',
      type: 'GET',
      data,
      success(data) {
        workingTimeSpan.data('needDefaultTime', false);
        if (data.default_time) {
          workingTimeSpan.text(data.default_time);
        }
        if (callback) { callback(); }
      },
    });
  }

  $(document).on('click', '.employee_details_container .save_task_duration', function () {
    const button = $(this);
    const assignedToTaskEmployee = button.closest('.employee_details_container').prev();
    const task = button.closest('.task_mobile');
    const taskDurationInput = button.closest('.task_duration_info').find('.tracked_time_input');
    const time = taskDurationInput.val();
    if (!validStringForTime(time)) {
      taskDurationInput.addClass('base-red-border');
      return;
    }
    const duration = timeToFloat(time);
    const activityPeriodParams = { activity_type: 'working_time', duration };
    const projectId = task.data('projectId');
    const supervisorId = task.data('supervisorId');
    const taskId = assignedToTaskEmployee.data('taskId');
    const date = task.data('date');
    $.ajax({
      url: '/employee_activity_periods',
      type: 'PUT',
      data: {
        date,
        project_id: projectId,
        supervisor_id: supervisorId,
        task_id: taskId,
        employee_activity_period: activityPeriodParams,
      },
      success(data) {
        if (data.status === 'ok') {
          taskDurationInput.removeClass('base-red-border');
          assignedToTaskEmployee.find('.task_tracked_time_span').text(time);
          assignedToTaskEmployee.find('.colored_employee').removeClass('base-red');
          assignedToTaskEmployee.find('.colored_employee').addClass('base-green');
          assignedToTaskEmployee.find('.fa-stopwatch').hide();
          assignedToTaskEmployee.find('.formatted_tracked_time').show();
          updateColorOfTaskClockIcon(task);
          button.hide();
        }
      },
    });
  });

  $(document).on('click', '#toggle_activity_periods', function () {
    $('#employee_activity_periods').show();
    $(this).hide();
  });

  function saveWorkingHours(spanForTime, h, m, ampm) {
    const time12h = `${h}:${m} ${ampm}`;
    const time24h = convertTime12to24(time12h);
    spanForTime.text(time24h);
    updateActivityPeriodCallback(spanForTime);
  }

  $(document).on('click', '#tasks_popup .task_tracked_time_span, #tasks_popup .container_with_task_tracked_time .fa-stopwatch', function () {
    selectTaskDuration($(this), '#tasks_popup');
  });

  $(document).on('click', '#employees_popup .task_tracked_time_span, #employees_popup .container_with_task_tracked_time .fa-stopwatch', function () {
    selectTaskDuration($(this), '#employees_popup');
  });

  function selectTaskDuration(target, popupSelector) {
    let timeSpan = target.closest('.container_with_task_tracked_time').find('.task_tracked_time_span');
    const popup = timeSpan.closest('.ui-dialog');
    popup.hide();
    const saveCallback = function (h, m) {
      if (!h && !m) {
        timeSpan = target.closest('.container_with_task_tracked_time').find('.formatted_tracked_time').hide();
        removeTaskTrackedTimeCallback(timeSpan, $(popupSelector));
      } else {
        const time = `${h}:${m}`;
        timeSpan.text(time);
        timeSpan.closest('.container_with_task_tracked_time').find('.fa-stopwatch').hide();
        updateTaskTrackedTimeCallback(timeSpan, $(popupSelector));
      }
    };
  }
});
